<form class="flex col w-100 md-w-75" autocomplete="nope" #form="ngForm">
    @for (employeeDetail of EMPLOYEE_DETAILS_MAP; track employeeDetail.key) {
        @if (employeeDetail.key === 'adminArea') {
            <mat-form-field class="loadable" [class.loading]="adminAreaInput.loading && !adminAreaInput.focused">
                <mat-label translate="payroll.taxForms.EMPLOYEE_DETAILS.{{ employeeDetail.key }}" />
                <ui-state-autocomplete
                    placeholder="{{ 'account.pleasePick' | translate }}"
                    name="adminArea"
                    [required]="true"
                    #adminArea="ngModel"
                    #adminAreaInput
                    [country]="taxForm.country"
                    [(ngModel)]="taxForm[employeeDetail.key]"
                ></ui-state-autocomplete>
                @if (adminArea.invalid) {
                    <mat-error>{{ adminArea.errors | formErrors }}</mat-error>
                }
            </mat-form-field>
        } @else if (employeeDetail.key === 'country') {
            <mat-form-field class="loadable" [class.loading]="countryInput.loading && !countryInput.focused">
                <mat-label translate="payroll.taxForms.EMPLOYEE_DETAILS.{{ employeeDetail.key }}" />
                <ui-country-autocomplete
                    placeholder="{{ 'account.pleasePick' | translate }}"
                    name="country"
                    [required]="true"
                    #country="ngModel"
                    #countryInput
                    [(ngModel)]="taxForm[employeeDetail.key]"
                ></ui-country-autocomplete>
                @if (country.invalid) {
                    <mat-error>{{ country.errors | formErrors }}</mat-error>
                }
            </mat-form-field>
        } @else if (employeeDetail.key === 'postCode') {
            @if (taxForm.country === 'Canada') {
                <mat-form-field>
                    <mat-label translate="payroll.taxForms.EMPLOYEE_DETAILS.{{ employeeDetail.key }}" />
                    <input
                        type="text"
                        placeholder="{{ 'account.postalCodePlaceHolder' | translate }}"
                        required
                        #postalCode="ngModel"
                        name="postalCode"
                        [textMask]="POSTAL_CODE_MASK"
                        [(ngModel)]="taxForm[employeeDetail.key]"
                        matInput
                    />
                    @if (postalCode.invalid) {
                        <mat-error>{{ postalCode.errors | formErrors }}</mat-error>
                    }
                </mat-form-field>
            } @else {
                <mat-form-field>
                    <mat-label translate="payroll.taxForms.EMPLOYEE_DETAILS.{{ employeeDetail.key }}" />
                    <input
                        type="text"
                        placeholder="{{ 'account.postalCodePlaceHolder' | translate }}"
                        required
                        #postalCode="ngModel"
                        name="postalCode"
                        [(ngModel)]="taxForm[employeeDetail.key]"
                        matInput
                    />
                    @if (postalCode.invalid) {
                        <mat-error>{{ postalCode.errors | formErrors }}</mat-error>
                    }
                </mat-form-field>
            }
        } @else {
            <mat-form-field>
                <mat-label translate="payroll.taxForms.EMPLOYEE_DETAILS.{{ employeeDetail.key }}" />
                <input
                    type="text"
                    [(ngModel)]="taxForm[employeeDetail.key]"
                    name="{{ employeeDetail.key }}"
                    #field="ngModel"
                    [required]="employeeDetail.required"
                    matInput
                />
                @if (field.invalid) {
                    <mat-error>{{ field.errors | formErrors }}</mat-error>
                }
            </mat-form-field>
        }
    }
</form>
